var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"j-page-search-wrap"},[(_vm.title)?_c('label',{staticClass:"j-page-search-wrap_label"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"j-page-search-wrap_content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }